import { SxProps, Theme } from '@mui/material';

export const titleDpValeFormSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-xl)',
	fontWeight: '800',
	color: '#333333',
	letterSpacing: '0px',
	marginBottom: '18px',
	width: '94%',

	// width: '50%',
	[theme.breakpoints.down('sm')]: {
		fontSize: 'var(--font-size-lg)',
	},
});

export const msgDpValeFormSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	color: '#707070',
	letterSpacing: '0px',
	margin: '0px',
	whiteSpace: 'nowrap',
};

export const fieldsDpValeFormSX: SxProps<Theme> = ({
	padding: '7px',
});

export const containerDpValeFormSX: SxProps<Theme> = ({

});
